enum TaskTemplateTeamOption {
  SelectedTeam = 'Selected team',
}

export default TaskTemplateTeamOption
